import { useFetch } from "~vue/api";

export const COLLABORATION_PROFILE_BOOTSTRAP_ICON_CLASS = "bi-globe";

export enum MainMenuPane {
    NEW_CHAT = "new_chat",
    HOME = "home",
    HISTORY = "history",
    GUIDED_SETUP = "guided_setup",
    PROFILE = "profile",
    COLLABORATION_PROFILE = "collaboration_profile",
    CONNECTIONS = "connections",
    PERFORMANCE_MANAGEMENT = "performance_management",
    MY_WORK = "my_work",
    JOURNEYS = "journeys",
    DEVELOPMENT_JOURNEYS = "development_journeys",
    COMPETENCY_ASSESSMENT = "competency_assessment",
    SCHNEIDER_ASSESSMENT = "schneider_assessment",
    REFLECTIONS = "reflections",
}

export type PaneNotificationCounts = Partial<Record<MainMenuPane, number>>;

export const ALL_PANES = Object.values(MainMenuPane);

export function paneNotificationAriaLabel(pane: MainMenuPane, label: string, count: number): string {
    if (count <= 0) {
        return label;
    }
    const countLabel = pane === MainMenuPane.MY_WORK ? `${count} new insight${count === 1 ? "" : "s"}` : `${count} new notification${count === 1 ? "" : "s"}`;
    return `${label}, ${countLabel}`;
}

export async function validateDisabledPanes(disabledPanes: MainMenuPane[]) {
    try {
        const panesURI = globalThis.encodeURIComponent(disabledPanes.join(","));
        const { data, error } = await useFetch(`/v1/navigation/validate?panes=${panesURI}`).json<{ disabled_panes: MainMenuPane[] }>();

        if (!error.value && data.value) {
            const payload = data.value;
            return disabledPanes.filter((p) => payload.disabled_panes.includes(p));
        }

        throw new Error("Failed to validate disabled navigation panes");
    } catch {
        // "Failed to fetch" errors are expected when users navigate away or have network issues.
        // The function degrades gracefully by returning the original disabledPanes.
        return disabledPanes;
    }
}
